import React from "react";

import { PASSWORD_CHECK_ORDER, PASSWORD_CHECK_TEXT } from "utils/auth/password";

import classes from "./styles.module.scss";

const PasswordRequirements = ({ passwordCheck }) => (
    <div className={classes.passwordCheckContainer}>
        <ul>
            {PASSWORD_CHECK_ORDER.map((check) => (
                <li
                    key={check}
                    className={passwordCheck[check] ? classes.passed : classes.failed}
                >
                    {PASSWORD_CHECK_TEXT[check]}
                </li>
            ))}
        </ul>
    </div>
);

export default PasswordRequirements;
